module.exports = __webpack_public_path__ + "img/Pink.10f39188.png";